import { OlympsConfigOlymp } from '@yandex-int/k-common';
import { Button, CertificateBanner, CERTIFICATE_LAYOUT, useIntl, useStaticUrls } from 'platform-components';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import ym from 'react-yandex-metrika';

import './results__teacher-certificate-banner.scss';

interface Props {
    olympConfig?: OlympsConfigOlymp;
}

export const TeacherCertificateBanner = ({ olympConfig }: Props) => {
    const { formatMessage } = useIntl();
    const history = useHistory();
    const { labPortfolio } = useStaticUrls();

    const i18n = (id: string) => formatMessage({ id: `specCourse.lessonView.teacherCertificateBanner.${id}` });

    const handleClick = useCallback(() => {
        ym('reachGoal', 'teacher_olymp_download_teacher_certificate');

        history.push(labPortfolio);
    }, [history, labPortfolio]);

    const imageSrc = olympConfig?.teacher?.results?.banners?.teacherCertificateBannerImgSrc || i18n('imgSrc');

    return (
        <CertificateBanner
            buttonProps={{
                view: Button.VIEW.ACTION,
            }}
            buttonText={i18n('goToPortfolio')}
            headerText={i18n('title')}
            imageSrc={imageSrc}
            layout={CERTIFICATE_LAYOUT.WIDE}
            onClick={handleClick}
            showButton={true}
            theme="yellow"
        />
    );
};
